// ── 모바일 스타일 A: 외부 레이아웃 + 히어로 + 카드 헤더 영역 ────────────────
// page, hero, 탭바, 선택 배너, 로딩/빈 상태, 매장 카드 헤더부 스타일

import { C, shadow } from './constants';

/** 전체 페이지 래퍼 */
export const page = {
  background: C.bg,
  minHeight: '100%',
  paddingBottom: 32,
};

// ── 히어로 ────────────────────────────────────────────────────────────────────

/** 히어로 배경 — full-width, 중첩 박스 없이 단일 레이어 */
export const hero = {
  background: `linear-gradient(160deg, ${C.heroTop} 0%, ${C.heroBot} 100%)`,
  padding: '28px 20px 0',
};

/** 히어로 내부 컨테이너 */
export const heroInner = {
  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
  width: '100%',
};

/** "정산받을돈" 레이블 */
export const heroNetLabel = {
  fontSize: 11, fontWeight: 600, color: 'rgba(255,255,255,0.45)',
  letterSpacing: '0.1em', textTransform: 'uppercase',
};

/** 순수익 금액 */
export const heroNetAmt = {
  fontSize: 38, fontWeight: 900, letterSpacing: '-0.03em',
  lineHeight: 1.05, marginTop: 2,
};

/** 차감/수입 통계 행 — 구분선으로 분리, 박스 없이 flat */
export const heroStats = {
  display: 'flex', alignItems: 'stretch',
  width: '100%',
  marginTop: 20,
  borderTop: '1px solid rgba(255,255,255,0.12)',
};

/** 개별 통계 항목 */
export const heroStat = {
  flex: 1,
  display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
  gap: 3,
  padding: '12px 8px',
};

export const heroStatLabel = {
  fontSize: 10, color: 'rgba(255,255,255,0.45)',
  fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase',
};

export const heroStatVal = {
  fontSize: 15, fontWeight: 700,
  fontVariantNumeric: 'tabular-nums',
  whiteSpace: 'nowrap',
};

export const heroStatDivider = {
  width: 1, alignSelf: 'stretch',
  background: 'rgba(255,255,255,0.12)',
  flexShrink: 0,
};

/** 받은돈 행 — 차감/수입 아래 별도 행으로 분리해 넘침 방지 */
export const heroRecRow = {
  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
  width: '100%',
  padding: '8px 0',
  borderTop: '1px solid rgba(255,255,255,0.08)',
};

// ── 선택 배너 ─────────────────────────────────────────────────────────────────

/** 결제 선택 배너 (연결 유도) */
export const selBanner = {
  display: 'flex', alignItems: 'center', gap: 12,
  background: C.accentBg,
  borderBottom: `2px solid ${C.accent}`,
  padding: '12px 16px',
};
export const selBannerIcon = {
  width: 32, height: 32, borderRadius: '50%',
  background: C.accent, color: '#fff',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  fontSize: 16, flexShrink: 0, fontWeight: 700,
};
export const selBannerText = {
  flex: 1, display: 'flex', flexDirection: 'column', gap: 1,
};
export const selBannerTitle = { fontSize: 13, fontWeight: 700, color: C.accent };
export const selBannerSub   = { fontSize: 11, color: C.subDark };
export const selCancelBtn = {
  background: 'none', border: `1.5px solid ${C.accent}`,
  borderRadius: 7, padding: '5px 12px',
  fontSize: 12, fontWeight: 600, color: C.accent, cursor: 'pointer',
  flexShrink: 0,
};

// ── 탭 ────────────────────────────────────────────────────────────────────────

/** 담당매장/미연결결제 내부 탭바 */
export const tabBar = {
  display: 'flex', alignItems: 'center',
  background: C.card,
  borderBottom: `1px solid ${C.border}`,
  padding: '0 16px',
  position: 'sticky', top: 0, zIndex: 10,
  boxShadow: shadow.sm,
};
export const tab = {
  flex: 1, padding: '14px 0',
  background: 'none', border: 'none',
  // C.sub(var(--text-muted))은 다크모드에서 #4b5878(어두운색)으로 뒤집혀 배경과 묻힘 → C.subDark(var(--text-sub)) 사용
  fontSize: 14, fontWeight: 600, color: C.subDark,
  cursor: 'pointer',
  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
  borderBottom: '2.5px solid transparent',
  transition: 'color 0.15s, border-color 0.15s',
};
export const tabActive   = { color: C.accent, borderBottom: `2.5px solid ${C.accent}` };
export const tabBadge = {
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
  minWidth: 18, height: 18,
  background: C.border, color: C.subDark,
  borderRadius: 9, fontSize: 10, fontWeight: 700,
  padding: '0 5px',
};
export const tabBadgeActive = { background: C.accentBg, color: C.accent };
export const refreshIconBtn = {
  background: 'none', border: 'none',
  padding: '12px 4px', cursor: 'pointer',
  color: C.sub, display: 'flex', alignItems: 'center',
  flexShrink: 0,
};

/** 탭 컨텐츠 — 좌우 패딩 최소화해 카드 최대 너비 확보 */
export const tabContent = { padding: '8px 4px 0' };

/** 매장카드/날짜순 서브탭 바 — 항상 다크 배경 고정 (C.main=var(--text)은 다크모드에서 흰색으로 뒤집힘) */
export const subTabBar = {
  display: 'flex', alignItems: 'center',
  background: 'var(--std-navy-surface, #0f1b35)',
  padding: '0 16px',
  borderBottom: `1px solid rgba(255,255,255,0.08)`,
};
export const subTab = {
  flex: 1, padding: '12px 0',
  background: 'none', border: 'none',
  fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.45)',
  cursor: 'pointer',
  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
  borderBottom: '2.5px solid transparent',
  transition: 'color 0.15s, border-color 0.15s',
};
export const subTabActive = { color: '#fff', borderBottom: '2.5px solid #6ee7b7' };

// ── 로딩 / 빈 상태 ────────────────────────────────────────────────────────────

export const loadWrap = { display: 'flex', flexDirection: 'column', gap: 8 };
export const loadCard = {
  background: C.card, borderRadius: 14,
  padding: '16px 16px', boxShadow: shadow.sm,
};
export const loadLine = {
  background: 'var(--bg-subtle)', borderRadius: 4,
  animation: 'pulse 1.4s ease-in-out infinite',
};

export const emptyWrap = {
  padding: '48px 24px', textAlign: 'center',
  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8,
};
export const emptyIcon = { fontSize: 36, marginBottom: 4 };
export const emptyText = { fontSize: 15, fontWeight: 600, color: C.subDark };
export const emptySub  = { fontSize: 13, color: C.sub };

// ── 매장 카드 헤더 ────────────────────────────────────────────────────────────

export const storeCard = {
  background: C.card, borderRadius: 14, marginBottom: 6,
  boxShadow: shadow.md, overflow: 'hidden',
  border: `1.5px solid ${C.borderLight}`,
  transition: 'box-shadow 0.15s, border-color 0.15s, background 0.15s',
};
export const cardHead = {
  padding: '14px 16px 0',
  cursor: 'pointer', userSelect: 'none',
  display: 'flex', flexDirection: 'column', gap: 5,
};
export const cardHeadTop = {
  display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8,
};
export const cardHeadTopLeft = {
  flex: 1, minWidth: 0,
  display: 'flex', flexDirection: 'column', gap: 3,
};
export const cardTopRow    = { display: 'flex', alignItems: 'center', gap: 6 };
export const storeDate     = { fontSize: 11, fontWeight: 600, color: C.sub };
export const connectHint   = {
  fontSize: 10, fontWeight: 700, color: C.accent,
  background: C.accentBg, padding: '1px 6px', borderRadius: 4,
};
export const storeName = {
  fontSize: 17, fontWeight: 700, color: C.main,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
};

export const cardAmtBar = {
  display: 'flex', alignItems: 'center',
  marginLeft: -16, marginRight: -16,
  marginTop: 6,
  padding: '8px 16px',
  background: 'var(--bg-subtle)',
  borderTop: `1px solid ${C.borderLight}`,
};
export const cardAmtItem = {
  flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
  minWidth: 0,
};
export const cardAmtDivider = { width: 1, height: 26, background: C.borderLight, flexShrink: 0 };
export const cardAmtLabel   = { fontSize: 9, color: C.sub, fontWeight: 500, letterSpacing: '0.04em' };
export const cardAmtVal = {
  fontSize: 12, fontWeight: 700,
  whiteSpace: 'nowrap',
  fontVariantNumeric: 'tabular-nums',
};

export const contractSummary = {
  fontSize: 11, color: C.sub,
  overflow: 'hidden', maxWidth: '100%', lineHeight: 1.4,
};
export const contractSvcRow  = { display: 'flex', alignItems: 'center', gap: 4, marginTop: 1 };
export const svcBadge = {
  fontSize: 9, fontWeight: 700, color: '#7c3aed',
  background: '#ede9fe', padding: '1px 4px', borderRadius: 3, flexShrink: 0,
};
export const contractSvcText = {
  fontSize: 10, color: C.sub,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
};
export const toggleChevron = {
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  transition: 'transform 0.2s ease',
  flexShrink: 0, marginTop: 2,
};
